module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-group"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'User Group'
        } ]
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("User Group")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar User Group\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createUsergroup()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                User Group\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.userGroups,
      "headers": _vm.headers,
      "hasAction": true,
      "has-custom-pagination": false,
      "custom-pagination-total-items": _vm.userGroups.length,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editUserGroup()
      },
      "changePage": function($event) {
        _vm.pageNumber = $event
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headers[$event.key]
        }
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbb4a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/user_group/components/UserGroup.vue
// module id = 2136
// module chunks = 1